
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[campaign]",
      function () {
        return require("private-next-pages/c/[campaign].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[campaign]"])
      });
    }
  